import React from "react";
import { useTheme } from "../../contexts/ThemeContext";

const Logo = ({
  size = 32,
  className = "",
  showText = false,
  textClassName = "",
  variant, // "dark" = black text (for light backgrounds), "light" = white text (for dark backgrounds)
}) => {
  const { mode } = useTheme();
  const isDark = mode === "dark";
  const logoSrc =
    variant === "dark"
      ? "/logo-dark.svg"
      : variant === "light"
        ? "/logo.svg"
        : isDark
          ? "/logo.svg"
          : "/logo-light.svg";

  // Calculate proper dimensions for the logo
  // New logo has viewBox "0 0 2763 654" (4.2:1 aspect ratio)
  const logoWidth = Math.round(size * 4.2); // Make it 4.2x wider to match the logo's aspect ratio
  const logoHeight = size;

  return (
    <div
      className={`flex items-center ${className} cursor-pointer`}
      onClick={() => (window.location.href = "/")}
    >
      <img
        src={logoSrc}
        alt="TeamGrid Logo"
        width={logoWidth}
        height={logoHeight}
        className="flex-shrink-0"
        style={{ objectFit: "contain" }}
      />

      {showText && (
        <span
          className={`text-xl font-bold ${
            isDark ? "text-white" : "text-slate-900"
          } ${textClassName}`}
        >
          TeamGrid
        </span>
      )}
    </div>
  );
};

export default Logo;
